import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import previewStyle from './ProductPreview.module.scss'
import style from './Skeleton.module.scss'

interface ICardsSkeletonProps {
  count: number
  // Cards per row, the same `fit` the product cards take, so the outlines sit in the cards' own slots.
  fit: number
}

// Costco's grid and carousel loader: one grey card outline per product — photo, title, price, button.
export const CardsSkeleton = ({ count, fit }: ICardsSkeletonProps) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()

  return (
    <div
      className={style.cards}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-GridSkeleton"
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={`${previewStyle.productPreview} ${viewport.mobile ? previewStyle.productPreviewMobile : ''} ${
            previewStyle[`productPreview${fit}PerRow`] || ''
          }`}
        >
          <div className={previewStyle.imageWrapper}>
            <div className={style.photo} />
          </div>
          <div className={style.text}>
            <div className={`${style.bar} ${style.short}`} />
            <div className={style.bar} />
            <div className={`${style.bar} ${style.medium}`} />
          </div>
          <div className={style.button} />
        </div>
      ))}
    </div>
  )
}

interface ILinesSkeletonProps {
  count: number
}

// Costco's cart loader: one grey line outline per cart line — thumb on the left, text beside it.
export const LinesSkeleton = ({ count }: ILinesSkeletonProps) => {
  const { t } = useSurveyLocale()

  return (
    <div role="status" aria-label={t('questions', 'ec', 'loading')} data-testid="SW-EC-CartSkeleton">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={style.line}>
          <div className={style.thumb} />
          <div className={style.text}>
            <div className={style.bar} />
            <div className={`${style.bar} ${style.medium}`} />
            <div className={`${style.bar} ${style.short}`} />
          </div>
        </div>
      ))}
    </div>
  )
}
